import globalStore from 'modules/global-store';

function get(id) {
  if (!id) {
    return null;
  }
  const products = globalStore.get('products', {});
  return products[id] || null;
}

function getToppings(product) {
  const toppings = [];

  if (product.toppings && product.toppings.length) {
    product.toppings.forEach((id) => {
      const _product = get(id);
      if (_product) {
        toppings.push(_product);
      }
    });
  }

  return toppings;
}

function push(product) {
  if (!product || !product.id) {
    return;
  }
  let products = globalStore.get('products');

  if (!products) {
    globalStore.set('products', {});
    products = globalStore.get('products');
  }

  products[product.id] = product;
}

function storeCartProduct(product) {
  const products = globalStore.get('cart_products', []);
  if (products.find((p) => p.id === product.id)) {
    return;
  }
  products.push(product);
  globalStore.set('cart_products', products);
}

function getCartProduct(id) {
  return globalStore.get('cart_products', []).find((i) => +i.id === +id);
}

export default {
  getToppings,
  get,
  push,
  storeCartProduct,
  getCartProduct,
};
